import { Expose, Type } from 'class-transformer'
import { ValidateNested } from 'class-validator'
import { PoliticianTitle } from '../../entity'

export class GetPoliticianTitlesDTO {

    @Expose()
    @ValidateNested()
    @Type( () => PoliticianTitle )
    politicianTitles!: PoliticianTitle[]

}